module.exports = __webpack_public_path__ + "static/pinesweeper-8d8e3f8c4f629bab9f044f969dafa9da.png";